import { render, staticRenderFns } from "./MetricsToggleConfigEdit.vue?vue&type=template&id=788d3540&"
import script from "./MetricsToggleConfigEdit.vue?vue&type=script&lang=ts&"
export * from "./MetricsToggleConfigEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
